import React, { useMemo } from "react";
import Link from "next/link";
import { scaleLinear } from "d3-scale";
import { geoCentroid } from "d3-geo";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import _ from "lodash";
const RaceCalendarMapView = ({
  races
}) => {
  const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
  const markers = _.chain(races).groupBy("state").toPairs().map(x => {
    return {
      state: x[0],
      count: x[1].length,
      races: x[1]
    };
  }).value();
  const mostRaces = _.chain(markers).orderBy(x => x.count, "desc").first().value();
  const maxValue = mostRaces?.count ?? 0;
  const popScale = useMemo(() => scaleLinear().domain([0, maxValue]).range([0, 24]), [maxValue]);
  const getGeo = (geographies, state) => {
    return geographies.find(x => x.properties.name === state);
  };
  return <>
      <div>
        <ComposableMap projection="geoAlbersUsa" data-sentry-element="ComposableMap" data-sentry-source-file="map-view.jsx">
          <Geographies geography={geoUrl} data-sentry-element="Geographies" data-sentry-source-file="map-view.jsx">
            {({
            geographies
          }) => <>
                {geographies.map(geo => <Geography key={geo.rsmKey} stroke="#FFF" geography={geo} fill="#DDD" />)}
                {markers.map(({
              state,
              count,
              races
            }) => {
              if (!state) {
                return;
              }
              const geo = getGeo(geographies, state);
              const centroid = geoCentroid(geo);
              return <Marker key={state} coordinates={centroid}>
                      <circle fill="#F53" stroke="#FFF" r={popScale(count)} />
                    </Marker>;
            })}
              </>}
          </Geographies>
        </ComposableMap>
      </div>
    </>;
};
export default RaceCalendarMapView;